var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-selector container mb-3"},[_c('div',{staticClass:"justify-content-center"},[_c('ncs-pagination-title'),_vm._v(" "),_c('ncs-pagination-links')],1),_vm._v(" "),_c('ncs-go-to-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }